import { Permissions } from '../client_auth/permissions'
import { uniqueIdForSSOExternalId } from './sso_external_id';

editDomainEntity.$inject = [
  'graph',
  'domains',
  'domainFlags',
  'contentProfiles',
  'adminApi',
  'auth',
]

export default function editDomainEntity(
  graph,
  domainService,
  domainFlags,
  contentProfiles,
  adminApi,
  auth
) {
  return {
    restrict: 'EA',
    scope: {
      refDomain: '=domain',
    },
    template: require('./_editDomainEntity.html'),
    link: function(scope, elm) {
      scope.domainFlags = domainFlags
      scope.contentProfileList = []
      scope.idpList = []
      auth.hasUserOpsPermission().then(hasPermission => {
        scope.hasUserOpsPermission = hasPermission;
      });

      // error handling
      scope.errorMessage = ''
      scope.showError = false

      // domain may be set asynchronously
      scope.$watch('refDomain', function(refDomain) {
        init()
      })

      // saving domain changes
      function isDomainEditInfoDirty(editedDomain, domain) {
        if (editedDomain.name !== domain.name) return true
        if (editedDomain.default_content_profile_id !== domain.default_content_profile_id)
          return true

        if (editedDomain.unique_id !== domain.unique_id) return true
        if (
          editedDomain.enforce_sso !== undefined &&
          editedDomain.enforce_sso !== domain.enforce_sso
        )
          return true

        if (
          editedDomain.allow_on_demand_sign_up !== undefined &&
          editedDomain.allow_on_demand_sign_up !== domain.allow_on_demand_sign_up
        )
          return true

        if (editedDomain.sso_provider_id !== domain.sso_provider_id) return true
        // if this is true, then we know there are no changes because
        // we already checked the names are equal
        if (!editedDomain.flags && !domain.flags) return false

        // check for differences in flags
        if (
          (!editedDomain.flags && domain.flags) ||
          (editedDomain.flags && !domain.flags) ||
          editedDomain.flags.length !== domain.flags.length
        )
          return true
        if (editedDomain.flags.sort().join() !== domain.flags.sort().join()) return true
        return false
      }
      function resetEditDomainForm() {
        scope.domainEditFormDirty = false
        scope.domainEditInfo = {
          flags: (scope.refDomain.flags && scope.refDomain.flags.concat()) || scope.refDomain.flags,
          name: scope.refDomain.name,
          default_content_profile_id: scope.refDomain.default_content_profile_id,
          unique_id: scope.refDomain.unique_id,
          usesSSOExternalId: scope.refDomain.unique_id === uniqueIdForSSOExternalId ? true : false,
          enforce_sso: scope.refDomain.enforce_sso,
          allow_on_demand_sign_up: scope.refDomain.allow_on_demand_sign_up,
          sso_provider_id: scope.refDomain.sso_provider_id
        }
      }
      scope.resetEditDomainForm = resetEditDomainForm
      function init() {
        if (scope.refDomain) {
          resetEditDomainForm()
        } else {
        }
        contentProfiles.getContentProfiles().then(profiles => {
          scope.contentProfileList = profiles
        })
        adminApi.getIdentityProvidersList().then(providers => {
          if (Array.isArray(providers)) {
            scope.idpList = [{ id: null, name: '-- No SSO Provider --' }].concat(providers)
          }
        })
      }

      scope.addFlag = function(domain, flag) {
        if (!domain || !flag) return
        if (!domain.flags) {
          domain.flags = []
        }
        if (domain.flags.indexOf(flag) < 0) {
          domain.flags.push(flag)
        } else {
          scope.errorMessage = '"' + domainFlags[flag] + ' (' + flag + ')" already on the domain'
          scope.showError = true
        }
      }
      scope.removeFlag = function(domain, i) {
        if (domain.flags && domain.flags.length > 0) {
          domain.flags.splice(i, 1)
          if (domain.flags.length === 0 && !scope.refDomain.flags) {
            delete domain.flags
          }
        }
      }
      scope.$watchCollection('domainEditInfo', function(editedDomain) {
        scope.domainEditFormDirty = isDomainEditInfoDirty(editedDomain, scope.refDomain)
      })
      scope.$watchCollection('domainEditInfo.flags', function(editedDomainFlags) {
        scope.domainEditFormDirty = isDomainEditInfoDirty(scope.domainEditInfo, scope.refDomain)
      })
      scope.$watch('domainEditInfo.usesSSOExternalId', function() {
        scope.domainEditInfo.unique_id = scope.domainEditInfo.usesSSOExternalId
          ? uniqueIdForSSOExternalId
          : ''
        scope.domainEditFormDirty = isDomainEditInfoDirty(scope.domainEditInfo, scope.refDomain)
      })
      scope.$watch('domainEditInfo.enforce_sso', function() {
        scope.domainEditFormDirty = isDomainEditInfoDirty(scope.domainEditInfo, scope.refDomain)
      })
      
      scope.$watch('domainEditInfo.allow_on_demand_sign_up', function() {
        scope.domainEditFormDirty = isDomainEditInfoDirty(scope.domainEditInfo, scope.refDomain)
      })

      scope.savingDomain = false
      scope.saveDomain = function(data) {
        if (confirm('Are you sure you want to update the domain name and/or flags?')) {
          delete data.usesSSOExternalId
          scope.savingDomain = true
          graph.updateDomain(scope.refDomain.uuid, data).then(
            function(updatedDomain) {
              scope.refDomain = updatedDomain

              // update the data in the edit form
              resetEditDomainForm()
              scope.savingDomain = false

              // also refresh the list of domains in the background
              domainService.refreshDomains()
            },
            function(reason) {
              scope.errorMessage = reason
              scope.showError = true
            }
          )
        } else {
          resetEditDomainForm()
        }
      }
    }
  }
}
